// 统一请求路径前缀在libs/axios.js中修改
import {
    getRequest,
    postRequest,
    putRequest,
    deleteRequest
} from '@/plugins/axios';


// 登陆
export const login = (params) => {
    return postRequest('/user/login', params)
}
// 注册
export const regist = (params) => {
    return postRequest('/user/registered', params)
}
// 请求权责列表数据
export const reqAccrualListData = (params) => {
    return postRequest('/data/searchShiXiangList', params)
}
// 请求字典表数据
export const reqDicListData = (params) => {
    return postRequest('/data/getDicList', params)
}
// 请求详情页数据
export const reqDetailsData = (id, params) => {
    return getRequest(`/data/getShiXiangDetail/${id}`, params)
}
// 请求村居级详情页数据
export const reqDetailsDataByCont = (id, params) => {
    return getRequest(`/data/getShiXiangDetailByCont/${id}`, params)
}
// 负面清单菜单
export const reqNegativeDicData = (params) => {
    return postRequest('/fumian/getFumianDicList', params)
}
// 负面清单内容列表
export const reqNegativeListData = (params) => {
    return postRequest('/fumian/getFumianContList', params)
}